// Centraliza la generación de todos los PDFs y Recibos relacionados a liquidaciones.
// Así solo aquí importamos los writers concretos.
// Si en el futuro quieres cambiar jsPDF por otra librería, solo tocas este archivo.

import genPDF from "./pdfWriter";     // Writer general (Tarifa / Honorario global)
import genPDF2 from "./pdfWriter2";   // Writer por profesional (honorario)
import pdfrecibo from "./pdfrecibo";  // Writer de recibo (profesional)
import { saveArrayBufferToDisk } from "../../../utils/tauriFileSave";

// Helpers internos para construir estructuras reutilizables.
// Cada build* devuelve un objeto con las propiedades esperadas por los writers existentes.

function buildTarifaData({
  liquidacionSinFiltro,
  gastosFiltrados,
  asistenciasFiltradas,
  pacienteNombre,
  fechainicio,
  fechafin,
  montoAnticipos = 0,
  _,
}) {
  const marcs = liquidacionSinFiltro.filter(l => l.paraTarifa === "SI");
  const gastos = gastosFiltrados.filter(g => g.paraTarifa === "SI");
  const asistencias = asistenciasFiltradas.filter(a => a.paratarifa === "SI");

  const sumGastos = _.sumBy(gastos, g => Number(g.monto));
  const sumAsistencias = _.sumBy(asistencias, a => Number(a.tarifa));
  const sumMarcs = _.sumBy(marcs, i =>
    Number(
      i.CostoHoraEmpresa *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraEmpresa * i.horasferiado * i.porcentajeferiado) / 100
    )
  );

  return {
    dato: marcs,
    tipo: "Tarifa",
    inicio: fechainicio,
    fin: fechafin,
    datgastos: gastos,
    Sumgastos: sumGastos,
    Suma: sumMarcs,
    dataasistencias: asistencias,
    Sumasistencias: sumAsistencias,
    Sumanticipos: Number(montoAnticipos) || 0,
    Paciente: pacienteNombre,
  };
}

function buildHonorarioData({
  liquidacionSinFiltro,
  gastosFiltrados,
  asistenciasFiltradas,
  pacienteNombre,
  fechainicio,
  fechafin,
  _,
}) {
  const marcs = liquidacionSinFiltro.filter(l => l.paraHonorario === "SI");
  const gastos = gastosFiltrados.filter(g => g.paraHonorario === "SI");
  const asistencias = asistenciasFiltradas.filter(a => a.parahonorario === "SI");

  const sumGastos = _.sumBy(gastos, g => Number(g.monto));
  const sumAsistencias = _.sumBy(asistencias, a => Number(a.honorario));
  const sumMarcs = _.sumBy(marcs, i =>
    Number(
      i.CostoHoraProfesional *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraProfesional * i.horasferiado * i.porcentajeferiado) / 100
    )
  );

  return {
    dato: marcs,
    tipo: "Honorario",
    inicio: fechainicio,
    fin: fechafin,
    datgastos: gastos,
    Sumgastos: sumGastos,
    Suma: sumMarcs,
    dataasistencias: asistencias,
    Sumasistencias: sumAsistencias,
    Paciente: pacienteNombre,
  };
}

function buildProfesionalHonorarioData({
  profesionalId,
  liquidacionSinFiltro,
  gastosFiltrados,
  asistenciasFiltradas,
  pacienteNombre,
  fechainicio,
  fechafin,
  nombreUsuario,
  _,
}) {
  const marcs = liquidacionSinFiltro.filter(
    l => l.paraHonorario === "SI" && (l.IdUsuario == profesionalId || l.idusuario == profesionalId)
  );
  const gastos = gastosFiltrados.filter(
    g => g.paraHonorario === "SI" && (g.idUsuario == profesionalId || g.IdUsuario == profesionalId)
  );
  const asistencias = asistenciasFiltradas.filter(
    a => a.parahonorario === "SI" && (a.asignado == profesionalId || a.IdUsuario == profesionalId)
  );

  const sumGastos = _.sumBy(gastos, g => Number(g.monto));
  const sumAsistencias = _.sumBy(asistencias, a => Number(a.honorario));
  const sumMarcs = _.sumBy(marcs, i =>
    Number(
      i.CostoHoraProfesional *
        (Number(Number(i.horashoraextra).toFixed(2)) + i.horascalculadas) +
        (i.CostoHoraProfesional * i.horasferiado * i.porcentajeferiado) / 100
    )
  );

  return {
    dato: marcs,
    tipo: "Honorario",
    inicio: fechainicio,
    fin: fechafin,
    datgastos: gastos,
    Sumgastos: sumGastos,
    Suma: sumMarcs,
    prof: nombreUsuario,
    dataasistencias: asistencias,
    Sumasistencias: sumAsistencias,
    Paciente: pacienteNombre,
  };
}

// API pública

export function generateTarifaPDF(params) {
  const _ = require("lodash");
  const data = buildTarifaData({ ...params, _ });
  genPDF(data);
}

export function generateHonorarioPDF(params) {
  const _ = require("lodash");
  const data = buildHonorarioData({ ...params, _ });
  genPDF(data);
}

export function generateProfesionalHonorarioPDF(params) {
  const _ = require("lodash");
  const data = buildProfesionalHonorarioData({ ...params, _ });
  genPDF2(data);
}

export function generateReciboProfesional(params) {
  // Genera un recibo por profesional (requiere número de recibo externo).
  const _ = require("lodash");
  const {
    profesionalId,
    liquidacionSinFiltro,
    gastosFiltrados,
    asistenciasFiltradas,
    pacienteNombre,
    fechainicio,
    fechafin,
    nombreUsuario,
    recibo,
  } = params;

  const data = buildProfesionalHonorarioData({
    profesionalId,
    liquidacionSinFiltro,
    gastosFiltrados,
    asistenciasFiltradas,
    pacienteNombre,
    fechainicio,
    fechafin,
    nombreUsuario,
    _,
  });

  const montoliquidado = data.Suma + data.Sumgastos + data.Sumasistencias;

  pdfrecibo({
    ...data,
    recibo,
    montoliquidado,
  });

  return { montoliquidado };
}

// ========== Funciones con Tauri para guardar PDFs ==========
// Estas funciones generan el PDF y luego lo guardan usando el helper de Tauri.

/**
 * Genera PDF de tarifa y lo guarda usando Tauri dialog + fs.
 * @param {Object} params - Parámetros para generar el PDF
 * @returns {Promise<string|null>} - Ruta del archivo guardado o null si se canceló
 */
export async function generateTarifaPDFAndSave(params) {
  const _ = require("lodash");
  const { jsPDF } = require("jspdf");
  
  const data = buildTarifaData({ ...params, _ });
  
  // Importar dinámicamente el pdfWriter y generar el PDF
  const pdfWriterModule = await import("./pdfWriter");
  const doc = pdfWriterModule.generatePDFDocument(data);
  
  // Obtener el PDF como ArrayBuffer
  const pdfArrayBuffer = doc.output('arraybuffer');
  
  // Construir nombre de archivo
  const fileName = `LIQUIDACION ${data.Paciente} ${data.inicio} al ${data.fin}.pdf`;
  
  // Guardar usando Tauri
  return await saveArrayBufferToDisk(pdfArrayBuffer, fileName, {
    title: 'Guardar PDF de Tarifa',
    filters: [{ name: 'PDF', extensions: ['pdf'] }]
  });
}

/**
 * Genera PDF de honorario y lo guarda usando Tauri dialog + fs.
 * @param {Object} params - Parámetros para generar el PDF
 * @returns {Promise<string|null>} - Ruta del archivo guardado o null si se canceló
 */
export async function generateHonorarioPDFAndSave(params) {
  const _ = require("lodash");
  const { jsPDF } = require("jspdf");
  
  const data = buildHonorarioData({ ...params, _ });
  
  // Importar dinámicamente el pdfWriter y generar el PDF
  const pdfWriterModule = await import("./pdfWriter");
  const doc = pdfWriterModule.generatePDFDocument(data);
  
  // Obtener el PDF como ArrayBuffer
  const pdfArrayBuffer = doc.output('arraybuffer');
  
  // Construir nombre de archivo
  const fileName = `HONORARIO ${data.Paciente} ${data.inicio} al ${data.fin}.pdf`;
  
  // Guardar usando Tauri
  return await saveArrayBufferToDisk(pdfArrayBuffer, fileName, {
    title: 'Guardar PDF de Honorario',
    filters: [{ name: 'PDF', extensions: ['pdf'] }]
  });
}

/**
 * Genera PDF de honorario por profesional y lo guarda usando Tauri dialog + fs.
 * @param {Object} params - Parámetros para generar el PDF
 * @returns {Promise<string|null>} - Ruta del archivo guardado o null si se canceló
 */
export async function generateProfesionalHonorarioPDFAndSave(params) {
  const _ = require("lodash");
  const { jsPDF } = require("jspdf");
  
  const data = buildProfesionalHonorarioData({ ...params, _ });
  
  // Importar dinámicamente el pdfWriter2 y generar el PDF
  const pdfWriterModule = await import("./pdfWriter2");
  const doc = pdfWriterModule.generatePDFDocument(data);
  
  // Obtener el PDF como ArrayBuffer
  const pdfArrayBuffer = doc.output('arraybuffer');
  
  // Construir nombre de archivo
  const fileName = `HONORARIO ${data.prof} ${data.Paciente} ${data.inicio} al ${data.fin}.pdf`;
  
  // Guardar usando Tauri
  return await saveArrayBufferToDisk(pdfArrayBuffer, fileName, {
    title: 'Guardar PDF de Honorario Profesional',
    filters: [{ name: 'PDF', extensions: ['pdf'] }]
  });
}

/**
 * Genera recibo de profesional y lo guarda usando Tauri dialog + fs.
 * @param {Object} params - Parámetros para generar el recibo
 * @returns {Promise<{montoliquidado: number, filePath: string|null}>} - Monto liquidado y ruta del archivo
 */
export async function generateReciboProfesionalAndSave(params) {
  const _ = require("lodash");
  const { jsPDF } = require("jspdf");
  
  const {
    profesionalId,
    liquidacionSinFiltro,
    gastosFiltrados,
    asistenciasFiltradas,
    pacienteNombre,
    fechainicio,
    fechafin,
    nombreUsuario,
    recibo,
  } = params;

  const data = buildProfesionalHonorarioData({
    profesionalId,
    liquidacionSinFiltro,
    gastosFiltrados,
    asistenciasFiltradas,
    pacienteNombre,
    fechainicio,
    fechafin,
    nombreUsuario,
    _,
  });

  const montoliquidado = data.Suma + data.Sumgastos + data.Sumasistencias;

  // Importar dinámicamente el pdfrecibo y generar el PDF
  const pdfReciboModule = await import("./pdfrecibo");
  const doc = pdfReciboModule.generateReciboDocument({
    ...data,
    recibo,
    montoliquidado,
  });

  // Obtener el PDF como ArrayBuffer
  const pdfArrayBuffer = doc.output('arraybuffer');
  
  // Construir nombre de archivo
  const fileName = `RECIBO ${recibo} ${data.prof} ${data.Paciente}.pdf`;
  
  // Guardar usando Tauri
  const filePath = await saveArrayBufferToDisk(pdfArrayBuffer, fileName, {
    title: 'Guardar Recibo',
    filters: [{ name: 'PDF', extensions: ['pdf'] }]
  });

  return { montoliquidado, filePath };
}
